var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "avatarContainer",
      class: [
        "avatar-container",
        { "light-mode": _vm.$route.meta.headerColor === "light" }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "avatar",
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [_vm._v(_vm._s(_vm.getUserInitials()))]
      ),
      _vm.isOpen
        ? _c("div", { staticClass: "user-dropdown" }, [
            _c("div", { staticClass: "name-container" }, [
              _c("div", { staticClass: "initials" }, [
                _vm._v(_vm._s(_vm.getUserInitials()))
              ]),
              _c("div", { staticClass: "names" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.$store.getters.getUser.fullName))
                ]),
                _c("div", { staticClass: "email" }, [
                  _vm._v(_vm._s(_vm.$store.getters.getUser.email))
                ]),
                _vm.$route.fullPath.includes("/gop")
                  ? _c(
                      "div",
                      {
                        staticClass: "country",
                        on: { click: _vm.openCountrySelect }
                      },
                      [
                        _c("div", { staticClass: "country-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$store.getters.getUser.gopUserCountry?.name ||
                                "Country not selected"
                            )
                          )
                        ]),
                        _c("img", {
                          staticClass: "mobile-icon",
                          attrs: {
                            src: require("@/drc/assets/icons/edit-blue.svg"),
                            alt: "Edit"
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "splitter" }),
            _c(
              "div",
              { staticClass: "logout-button", on: { click: _vm.handleLogout } },
              [_vm._v(" " + _vm._s(_vm.$t("sideMenu.logout")) + " ")]
            )
          ])
        : _vm._e(),
      _vm.showChooseCountry
        ? _c("gopChooseLanguage", {
            on: {
              closeDialog: _vm.hideChooseLanguagePopup,
              submit: _vm.submitNewCountry
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }